"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var Button_1 = __importDefault(require("@sportnet/ui/lib/Button"));

var MediaManagerImage_1 = __importDefault(require("@sportnet/ui/lib/MediaManagerImage"));

var em_1 = __importDefault(require("polished/lib/helpers/em"));

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var sportnet_utilities_1 = require("sportnet-utilities");

var styled_components_1 = __importDefault(require("styled-components"));

var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");

var polished_1 = require("polished");

var BORDER_RADIUS = 4;
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: ", "px;\n  margin-bottom: ", ";\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n  background-color: ", ";\n  ", " {\n    flex-direction: row;\n  }\n"], ["\n  box-shadow: 0px 3px 7px 0 rgba(0, 0, 0, 0.2);\n  display: flex;\n  flex-wrap: wrap;\n  border-radius: ", "px;\n  margin-bottom: ", ";\n  flex-direction: column;\n  align-items: flex-start;\n  overflow: hidden;\n  background-color: ", ";\n  ", " {\n    flex-direction: row;\n  }\n"])), BORDER_RADIUS, function (_a) {
  var theme = _a.theme;
  return em_1["default"](theme.grid.gutterWidth);
}, function (_a) {
  var theme = _a.theme;
  return polished_1.readableColor(theme.app.textColor, '#333', '#fff');
}, utilities_1.mb('xs'));
var ButtonWrapper = styled_components_1["default"].a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-decoration: none;\n  color: inherit;\n  margin-top: 0.7em;\n"], ["\n  text-decoration: none;\n  color: inherit;\n  margin-top: 0.7em;\n"])));
var Description = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var WrapperDescription = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  padding: ", ";\n  flex: 1;\n"], ["\n  display: flex;\n  align-self: stretch;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  flex-direction: column;\n  padding: ", ";\n  flex: 1;\n"])), function (_a) {
  var theme = _a.theme;
  return em_1["default"](theme.grid.gutterWidth);
});
var TitleImage = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 100%;\n  ", " {\n    flex-shrink: 0;\n    width: 33%;\n  }\n"], ["\n  width: 100%;\n  ", " {\n    flex-shrink: 0;\n    width: 33%;\n  }\n"])), utilities_1.mb('xs'));
var Name = styled_components_1["default"]('div')(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"], ["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"])));

var WidgetDocument =
/** @class */
function (_super) {
  __extends(WidgetDocument, _super);

  function WidgetDocument() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  WidgetDocument.prototype.renderItem = function (name, url, description, picture) {
    return react_1["default"].createElement(Wrapper, null, picture && react_1["default"].createElement(TitleImage, {
      picture: picture,
      naturalWidth: 400,
      naturalHeight: 300,
      script: "resize"
    }), react_1["default"].createElement(WrapperDescription, null, name && react_1["default"].createElement(Name, null, name || url), description && react_1["default"].createElement(Description, null, description), react_1["default"].createElement(ButtonWrapper, {
      target: "_blank",
      href: url
    }, react_1["default"].createElement(Button_1["default"], {
      icon: "attach",
      basic: true,
      primary: true
    }, "Stiahn\xFA\u0165"))));
  };

  WidgetDocument.prototype.render = function () {
    var _this = this;

    var _a = this.props.data,
        name = _a.title,
        publicUrl = _a.uri;
    var items = sportnet_utilities_1.getProp(this.props, ['data', 'files'], null);

    if (!items && !publicUrl && this.props.renderEmpty) {
      return this.props.renderEmpty(this.props.data.type);
    }

    if (items) {
      return items.map(function (item, idx) {
        var name = item.name,
            publicUrl = item.public_url,
            picture = item.picture,
            description = item.description;

        if (publicUrl) {
          return _this.renderItem(name, publicUrl, description, picture);
        }

        return null;
      });
    }

    if (publicUrl) {
      // toto je pre pripad spatnej kompatibility
      // widget document zhruba od septembra 2018 podporuje
      // pridavanie viacero dokumentov naraz
      return this.renderItem(name, publicUrl);
    }

    return null;
  };

  return WidgetDocument;
}(react_1.PureComponent);

WidgetDocument.propTypes = {
  data: prop_types_1["default"].shape({
    files: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
      public_url: prop_types_1["default"].string.isRequired,
      name: prop_types_1["default"].string.isRequired
    }).isRequired)
  }).isRequired
};
exports["default"] = WidgetDocument;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;